import { AfterViewInit, Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { EventService } from 'src/app/core/services/event.service';
import { ValidatorsService } from 'src/app/services/validators.service';

import { TopbarComponent } from '../topbar/topbar.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { FooterComponent } from '../footer/footer.component';
import { RightsidebarComponent } from '../rightsidebar/rightsidebar.component';
import { ToastModule } from 'primeng/toast';
import { SubscriptionAlertBannerComponent } from 'src/app/core/components/subscription-alert-banner/subscription-alert-banner.component';
import { ModalRefreshTokenComponent } from 'src/app/pages/management/user-profile/components/modal-refresh-token/modal-refresh-token.component';

@Component({
  selector: 'app-vertical',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TopbarComponent,
    SidebarComponent,
    BreadcrumbComponent,
    FooterComponent,
    RightsidebarComponent,
    ToastModule,
    SubscriptionAlertBannerComponent,
    ModalRefreshTokenComponent
  ],
  templateUrl: './vertical.component.html',
  styles: [],
})
export class VerticalComponent implements OnInit, AfterViewInit {
  isCondensed = false;
  @Input() breadcrumbs: any = [];
  // sidebartype: string;
  validatorsService = inject(ValidatorsService);
  authService = inject(AuthService);
  router = inject(Router);
  eventService = inject(EventService);

  constructor() {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        document.body.classList.remove('sidebar-enable');
      }
    });
  }

  ngOnInit() {
    document.body.setAttribute('data-layout', 'vertical');
  }

  isMobile() {
    const ua = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua);
  }

  ngAfterViewInit() {
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  getValidSucursal() {
    if (this.authService._user()?.role.name == 'SUPER_ADMIN') {
      return true;
    } else {
      return this.validatorsService.id_sucursal();
    }
  }
}
